import React, {useState} from "react";
import "../../css/about/contacts.css";
import "../../css/about/about-refresh.css";
import Navigation from "../utils/Navigation";
import SeoHelmet from "../utils/seo";
import {useLocation} from "react-router-dom";
import {findElementByLink} from "../utils/siteStructure";
import siteStructure from "../siteStructure.json";
import {useTheme} from "../header/Header";

const locations = [
    {id: 'office', title: 'Офис продаж', subtitle: 'Чебоксары',
        address: 'Чебоксары, ул. Ленинградская, 36', coordinates: [56.137945, 47.245739]},
    {id: 'plant', title: 'Завод «Сеспель»', subtitle: 'Деревня Сидуккасы',
        address: 'Чувашская Республика, Моргаушский район, деревня Сидуккасы, Сидуковская улица, 39', coordinates: [56.041734, 46.765147]},
    {id: 'dealer', title: 'Официальный дилер', subtitle: 'Стоянка техники в наличии',
        address: 'Моргаушский район, д. Тереси, ул. Новая, дом 71', coordinates: [56.040978, 46.808087]},
];

function mapLink(location) {
    return `https://yandex.ru/maps/?pt=${location.coordinates[1]},${location.coordinates[0]}&z=16&l=map`;
}

export default function Contacts() {
    const location = useLocation();
    const siteData = findElementByLink(siteStructure, location.pathname);
    const seo = siteData?.seo || {title: 'Контакты', description: ''};
    const {theme} = useTheme();
    const [selectedId, setSelectedId] = useState('office');
    const selectedLocation = locations.find(item => item.id === selectedId);

    return (
        <div className="overlay">
            <SeoHelmet title={seo.title} description={seo.description}/>
            <Navigation/>
            <div className={`complexBack ${theme}`}/>
            <main className={`contacts-container about-page contacts-refresh ${theme}`}>
                <header className="about-page-heading">
                    <span className="about-eyebrow">Сеспель / Контакты</span>
                    <h1>Будем на связи</h1>
                    <p>Обсудим вашу задачу, поможем с выбором техники и подскажем, как добраться до нас.</p>
                </header>
                <section className="contact-channels" aria-label="Связаться с компанией">
                    <a className="contact-channel contact-channel-primary" href="tel:+78005511634">
                        <span className="contact-channel-label">Отдел продаж <span aria-hidden="true">↗</span></span>
                        <strong>8 (800) 551-16-34</strong>
                        <span>Многоканальный телефон</span>
                    </a>
                    <a className="contact-channel" href="mailto:zaosespel@yandex.ru">
                        <span className="contact-channel-label">Напишите нам <span aria-hidden="true">↗</span></span>
                        <strong>zaosespel@yandex.ru</strong>
                        <span>Вопросы о продукции и сотрудничестве</span>
                    </a>
                    <a className="contact-channel" href="tel:+78352225722">
                        <span className="contact-channel-label">Офис в Чебоксарах <span aria-hidden="true">↗</span></span>
                        <strong>+7 (8352) 22-57-22</strong>
                        <span>Городской телефон / факс</span>
                    </a>
                </section>
                <section className="contact-locations" aria-labelledby="contact-locations-title">
                    <div className="about-section-heading">
                        <span className="about-eyebrow">01 / Адреса</span>
                        <h2 id="contact-locations-title">Где нас найти</h2>
                        <p>Выберите площадку, чтобы увидеть её расположение на карте.</p>
                    </div>
                    <div className="contact-locations-grid">
                        <div className="contact-location-list" aria-label="Площадки компании">
                            {locations.map((item, index) => (
                                <button type="button" key={item.id}
                                        className={`contact-location ${selectedId === item.id ? 'is-selected' : ''}`}
                                        aria-pressed={selectedId === item.id} aria-controls="contact-map-panel"
                                        onClick={() => setSelectedId(item.id)}>
                                    <span className="contact-location-number">0{index + 1}</span>
                                    <span className="contact-location-copy">
                                        <strong>{item.title}</strong>
                                        <span className="contact-location-subtitle">{item.subtitle}</span>
                                        <span>{item.address}</span>
                                    </span>
                                    <span className="contact-location-arrow" aria-hidden="true">↗</span>
                                </button>
                            ))}
                        </div>
                        <div className="contact-map-panel" id="contact-map-panel">
                            <MapContact key={selectedLocation.id} selectedLocation={selectedLocation}/>
                            <div className="contact-map-caption">
                                <div aria-live="polite"><strong>{selectedLocation.title}</strong><p>{selectedLocation.address}</p></div>
                                <a href={mapLink(selectedLocation)} target="_blank" rel="noopener noreferrer">Открыть в Яндекс Картах <span aria-hidden="true">↗</span></a>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="contact-details" aria-labelledby="contact-details-title">
                    <div>
                        <span className="about-eyebrow">02 / Документы</span>
                        <h2 id="contact-details-title">Реквизиты компании</h2>
                        <p>ЗАО «Чебоксарское предприятие «Сеспель»</p>
                    </div>
                    <dl className="contact-requisites">
                        <div><dt>ИНН</dt><dd>2126002786</dd></div>
                        <div><dt>КПП</dt><dd>213001001</dd></div>
                        <div><dt>ОГРН</dt><dd>1022101277934</dd></div>
                    </dl>
                </section>
            </main>
        </div>
    );
}

function MapContact({selectedLocation}) {
    const [loaded, setLoaded] = useState(false);
    const center = `${selectedLocation.coordinates[1]},${selectedLocation.coordinates[0]}`;
    const points = locations.map(item => `${item.coordinates[1]},${item.coordinates[0]}`).join('~');
    const query = new URLSearchParams({ll: center, pt: points, z: '14', lang: 'ru_RU'});
    return (
        <div className="contact-interactive-map" aria-label={`Карта: ${selectedLocation.title}`}>
            {!loaded && <p className="contact-map-fallback" role="status">Загружаем карту. Если она недоступна, воспользуйтесь ссылкой под картой.</p>}
            <iframe title={`Яндекс Карты — ${selectedLocation.title}`}
                    src={`https://yandex.ru/map-widget/v1/?${query.toString()}`}
                    loading="lazy" allowFullScreen onLoad={() => setLoaded(true)}/>
        </div>
    );
}
